module.exports = __webpack_public_path__ + "static/tweetit-cover-6029857cec6ae580134c96348a1b85b0.png";